import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import BoonLogo from '../../assets/images/boon_logo.png';
import ButtonWithIcon from '../shared/ButtonWithIcon/ButtonWithIcon';
import Header from '../shared/Header/Header';

import styles from './NotFound.module.scss';

const NotFound = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className={styles.pageContainer}>
      <Header logo={BoonLogo} isPublic logoClassName="w-full h-[30px] rounded-none" />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.textContainer}>
            <h1 className={styles.title}>404</h1>
            <h2 className={styles.subtitle}>{t('errors.pageNotFound')}</h2>
            <p className={styles.description}>{t('errors.pageNotFoundDescription')}</p>
          </div>

          <div className={styles.actions}>
            <ButtonWithIcon
              text={t('goToHomePage')}
              imgClassName="btn-icon-36"
              textClassName="btn-icon-text-primary-40"
              variant="primary-36"
              onClick={handleGoHome}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
